// Numbers typed into report cells. <input type="number"> reports a dot ("8.75"), the
// app stores what the keyboard produced ("8,75"); with a comma, dots are thousands
// separators ("1.234,5"). Blank or unreadable input counts as 0, as in a sum.
// Mirrors CustomReports::DecimalParser, so the live totals match the PDF.
const DECIMAL_FORMAT = /^-?\d+(\.\d+)?$/

export function parseDecimal(raw) {
  let value = String(raw ?? "")
    .trim()
    .replaceAll(" ", "")
  if (value.includes(",")) value = value.replaceAll(".", "").replace(",", ".")
  return DECIMAL_FORMAT.test(value) ? Number(value) : 0
}

const DECIMAL_DISPLAY = new Intl.NumberFormat("de-DE", { maximumFractionDigits: 2 })

// German display with up to two decimals and no trailing zeros: 8,75 / 40 / 1.234,5
export function formatDecimal(value) {
  return DECIMAL_DISPLAY.format(value)
}
